import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const detail = () => import('./agreement-page');
const list = () => import('./agreements-page');
const depth = () => import('./depth'); // P3 commercial

// Contracts (ConnectWise Agreements). Owned by the agreements module.
export const routes: RouteObject[] = [
  { path: 'agreements', lazy: page(list, (m) => m.AgreementsPage) },
  { path: 'agreements/new', lazy: page(detail, (m) => m.NewAgreementPage) },
  { path: 'agreements/types', lazy: page(depth, (m) => m.AgreementTypesPage) },
  { path: 'agreements/uplift', lazy: page(depth, (m) => m.UpliftPage) },
  { path: 'agreements/:id', lazy: page(detail, (m) => m.AgreementPage) },
];
export const orgRoutes: RouteObject[] = [{ path: 'agreements', lazy: page(list, (m) => m.OrgAgreementsPage) }];
